import { render, staticRenderFns } from "./ModifyLeasesDialog.vue?vue&type=template&id=6f72438c&scoped=true"
import script from "./ModifyLeasesDialog.vue?vue&type=script&lang=js"
export * from "./ModifyLeasesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f72438c",
  null
  
)

export default component.exports